import { ArtStatusService, UserAccountsService } from '../services'
import { useContext } from 'react'
import { ArtPedingContext } from '../contexts/ArtPendingContext/ArtPendingContext'

export const UseCheckArtPending = () => {

  const {setArtStatus, artStatus} = useContext(ArtPedingContext)

  const handleVerifyHasArtPending = async() => {
    const userAccount = await UserAccountsService.getUserAccountsByLogin()
    const userAccountId = userAccount?.data?.uuid
    const artStatusAlreadyExistsResponse = await ArtStatusService.getArtStatusByUserAccount(userAccountId)
  
    if(artStatusAlreadyExistsResponse?.data && !artStatusAlreadyExistsResponse.data.isVisualized){
      setArtStatus(artStatusAlreadyExistsResponse.data)
    } else {
      setArtStatus(null)
    }
  }


  return { handleVerifyHasArtPending, artStatus, setArtStatus }
}
